import styled from "styled-components";
import React, { useEffect, useState } from 'react';
import { SalarySlipData } from '../../data/SalarySlipData';
import { jsPDF } from 'jspdf';
import { useLocation } from 'react-router-dom';
import html2canvas from 'html2canvas';
import harrierLogo from '../../images/harrer-logo.png';

const TABLE = styled.table`
    border: 1px solid;
`;
const TH = styled.th`
    border: 1px solid;
`;
const TD = styled.td`
    border: 1px solid;
`;

function SalarySlip() {

    const location = useLocation();
    const payrolls = location.state;
    // NOTE: Initializing with payrolls[0] is necessary for the first render,
    // but be aware that the useEffect immediately overwrites it and tries 
    // to generate PDFs for all payrolls.
    const [empPayroll, setEmpPayroll] = useState(payrolls[0]);

    useEffect(() => {
        // The logic inside this useEffect attempts to generate a PDF for every 
        // payroll in the array immediately upon component load/update, which is 
        // a complex side effect. It sets empPayroll and then tries to capture 
        // the *same* 'content' DOM element, which will only contain the data
        // from the *last* payroll set by setEmpPayroll in this loop. 
        // For a correct solution, you would need to iterate and render each 
        // payroll individually or use a ref and pass the specific data for PDF 
        // generation.
        payrolls.forEach((payroll) => {
            setEmpPayroll(payroll);
            const input = document.getElementById('content');
            html2canvas(input, { allowTaint: true, useCORS: true })
                .then(canvas => {
                    const imgWidth = 350;
                    const imgHeight = canvas.height * imgWidth / canvas.width;
                    const imgData = canvas.toDataURL('img/png');
                    const pdf = new jsPDF('p', 'mm', 'a4');
                    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
                    const employeeName = `${payroll.empPersonalDetails.first_name || ''} ${payroll.empPersonalDetails.last_name || ''}`.trim() || 'Employee';
                    pdf.save(`${employeeName} ${payroll.empPersonalDetails.employee_id}.pdf`);
                });
        })

        // A dependency array of [empPayroll] will cause an infinite loop because 
        // setEmpPayroll is called inside the effect. I've changed it to an empty 
        // array for demonstration, assuming the PDF generation should run once 
        // on mount, although the current implementation has flaws for batch PDF 
        // generation.
    }, []);

    const EarnLen = empPayroll.empSalComponents.length,
        DeductLen = empPayroll.deductionComponents.length;
    const len = EarnLen > DeductLen ? EarnLen : DeductLen;

    let total_pay = 0,
        total_deduction = 0;

    let row = []
    for (let i = 0; i < len; i++) {
        let temp = [];

        if (i < EarnLen) { //There is element in array
            temp.push(empPayroll.empSalComponents[i].component)
            temp.push(empPayroll.empSalComponents[i].amount)

            total_pay += empPayroll.empSalComponents[i].amount
        } else {
            temp.push("")
            temp.push("")
        }

        if (i < DeductLen) {
            temp.push(empPayroll.deductionComponents[i].component)
            temp.push(empPayroll.deductionComponents[i].amount)

            total_deduction += empPayroll.deductionComponents[i].amount
        } else {
            temp.push("")
            temp.push("")
        }

        row.push(temp)
    }

    const EarnLen1 = empPayroll.empEarningComponents.length,
        DeductLen1 = empPayroll.empDeductionComponents.length;
    const len1 = EarnLen1 > DeductLen1 ? EarnLen1 : DeductLen1;

    let row1 = []
    for (let i = 0; i < len1; i++) {
        let temp1 = [];

        if (i < EarnLen1) { //There is element in array
            temp1.push(empPayroll.empEarningComponents[i].deduction_earning_type);
            temp1.push(empPayroll.empEarningComponents[i].amount);

            // total_pay+=empPayroll.empSalComponents[i].amount
        } else {
            temp1.push("")
            temp1.push("")
        }

        if (i < DeductLen1) {
            temp1.push(empPayroll.empDeductionComponents[i].deduction_earning_type);
            temp1.push(empPayroll.empDeductionComponents[i].amount);

            // total_deduction+=empPayroll.deductionComponents[i].amount
        } else {
            temp1.push("")
            temp1.push("")
        }

        row1.push(temp1)
    }

    return (
        <div>
            {/* <button onClick={generateHTMLtoPDF}>Generate PDF from HTML</button> */}

            <div id='content' >

                <div style={{ padding: "40px", paddingLeft: '110px' }} >
                    <br></br>
                    <b style={{
                        textAlign: "justify"
                    }}>
                        <img className='logo-img' src={harrierLogo} alt='' />

                        <p>First Floor, Shanti Plaza at Shanti Park, Beltarodi Road, Besa, Nagpur - 440037, Maharashtra</p>
                        <p>Phone: 0712-6602104</p>
                        <p>Website: <a href="www.harriersys.com">www.harriersys.com</a></p>
                        <p>Mail : info@harriersys.com</p>

                        <br></br>

                        <p style={{ marginLeft: '15vw' }}>
                            Salary Slip for  <b>{empPayroll.selectedMonth} - {empPayroll.selectedYear}</b>
                        </p>

                    </b>

                    <TABLE className="table" style={{ width: 'max-content' }}>
                        <tbody >
                            <tr>
                                <TH>Name</TH>
                                <TD> {`${empPayroll.empPersonalDetails.first_name || ''} ${empPayroll.empPersonalDetails.last_name || ''}`.trim()} </TD>
                                <TH>Employee Code</TH>
                                <TD> {empPayroll.empPersonalDetails.employee_code} </TD>
                            </tr>
                            <tr>
                                <TH>Designation</TH>
                                <TD> {SalarySlipData.Designation} </TD>
                                <TH>Department</TH>
                                <TD> {SalarySlipData.Department} </TD>
                            </tr>
                            <tr>
                                <TH>Total No. of Days</TH>
                                <TD> {empPayroll.empPayroll._total_days} </TD>
                                <TH>ICICI A/c</TH>
                                <TD> {empPayroll.empPersonalDetails.ICICI_account_no} </TD>
                            </tr>
                            <tr>
                                <TH>Gender</TH>
                                <TD> {empPayroll.empPersonalDetails.gender} </TD>
                                <TH>PF A/c No.</TH>
                                <TD> {empPayroll.empPersonalDetails.pf_number} </TD>
                            </tr>
                            <tr>
                                <TD></TD>
                                <TD></TD>
                                <TH>ESI No.</TH>
                                <TD>{empPayroll.empPersonalDetails.ESINumber}</TD>
                            </tr>

                            <tr>
                                <TH>Total Leaves</TH>
                                <TD> {empPayroll.empPayroll.mTOTAL_LEAVES} </TD>
                                <TH>Total Unpaid Leaves</TH>
                                <TD> {empPayroll.empPayroll.mTOTAL_UNPAID_LEAVES} </TD>
                            </tr>

                            <tr>
                                <TD> &nbsp; </TD>
                                <TD> </TD>
                                <TD> </TD>
                                <TD> </TD>
                            </tr>
                            <tr>
                                <TH>Earnings</TH>
                                <TH>Amount (INR)</TH>
                                <TH>Deductions</TH>
                                <TH>Amount (INR)</TH>
                            </tr>

                            {
                                row.map((curElem) => {
                                    return (
                                        <tr key={curElem}>
                                            <TD> {curElem[0]} </TD>
                                            <TD> {curElem[1]} </TD>
                                            <TD> {curElem[2]} </TD>
                                            <TD> {curElem[3]} </TD>
                                        </tr>
                                    )
                                })
                            }

                            <tr>
                                <TD> &nbsp; </TD>
                                <TD> </TD>
                                <TD> </TD>
                                <TD> </TD>
                            </tr>

                            <tr>
                                <TH>Other Earnings</TH>
                                <TH>Amount (INR)</TH>
                                <TH>Other Deductions</TH>
                                <TH>Amount (INR)</TH>
                            </tr>

                            {
                                row1.map((curElem) => {
                                    return (
                                        <tr key={curElem}>
                                            <TD> {curElem[0]} </TD>
                                            <TD> {curElem[1]} </TD>
                                            <TD> {curElem[2]} </TD>
                                            <TD> {curElem[3]} </TD>
                                        </tr>
                                    )
                                })
                            }

                            <tr>
                                <TD> &nbsp; </TD>
                                <TD> </TD>
                                <TD> </TD>
                                <TD> </TD>
                            </tr>

                            <tr>
                                <TH>Total Pay (INR)</TH>
                                <TH>{empPayroll.empPayroll.mTOTAL_EARNING}</TH>
                                <TH>Total Deductions (INR)</TH>
                                <TH>{empPayroll.empPayroll.mTOTAL_DEDUCTION}</TH>
                            </tr>
                            <tr>
                                <TH>Net Pay (INR)</TH>
                                <TH>{empPayroll.empPayroll.mNET_SALARY}</TH>
                                <TD></TD>
                                <TD></TD>
                            </tr>
                        </tbody>
                    </TABLE>

                    <p style={{ marginLeft: '18vw' }}>
                        Powered by DigiCompany Payroll System
                    </p>

                </div>
            </div>
        </div>
    )
}

export default SalarySlip